import { BaseApi } from "api/BaseApi.ts";

import GetUserResponse = App.Http.Responses.User.GetUserResponse;
import LoginRequest = App.Http.Requests.Auth.LoginRequest;

class AuthApi extends BaseApi {
    /**
     * Login
     *
     * - Request: LoginRequest
     * - Response: GetUserResponse
     */
    async login(request: LoginRequest, silentError = false): Promise<GetUserResponse> {
        return await this.post<GetUserResponse, LoginRequest>("/auth", request, silentError ? { silentError } : undefined);
    }

    /**
     * Tenant Login
     *
     * - Request: LoginRequest
     * - Response: GetUserResponse
     */
    async loginToTenant(request: LoginRequest, tenantSlug: string, silentError = false): Promise<GetUserResponse> {
        return await this.post<GetUserResponse, LoginRequest>(
            `/${tenantSlug}/login`,
            request,
            silentError ? { silentError } : undefined
        );
    }

    /**
     * Logout
     *
     * - Request: /
     * - Response: just 200
     */
    async logout(): Promise<null> {
        return await this.delete<null>("/auth");
    }
}

export const authApi = new AuthApi();
